import {
    TransactionColumn,
    TransactionView,
} from "@common/types/views/transactionViews";
import { NamedView, ViewType } from "@common/types/views/views";
import { AccountingLedgerBasis } from "@common/types/domains/accounting/ledger";

export const createDefaultGLDrillDownTransactionView = (
    ledgerBasis: AccountingLedgerBasis | undefined,
    { isClassesEnabled }: { isClassesEnabled: boolean },
): NamedView<TransactionView> => ({
    id: "general-ledger-drilldown",
    name: "Cash ledger drilldown",
    type: ViewType.TRANSACTION,
    options: {
        bulkActions: true,
        selection: true,
    },
    filters: {},
    columns: [
        {
            id: TransactionColumn.DATE,
            options: {
                pin: "left",
            },
        },
        {
            id: TransactionColumn.SPLIT,
            options: {
                pin: "left",
            },
        },
        {
            id: TransactionColumn.BANK_DESCRIPTION,
        },
        {
            id: TransactionColumn.COUNTERPARTY,
        },
        {
            id: TransactionColumn.CATEGORY,
        },
        {
            id:
                ledgerBasis === AccountingLedgerBasis.accruals
                    ? TransactionColumn.ACCRUAL_LEDGER
                    : TransactionColumn.LEDGER,
        },
        ...(isClassesEnabled
            ? [{ id: TransactionColumn.CLASSES as const }]
            : []),
        {
            id: TransactionColumn.ACCOUNT,
        },
        {
            id: TransactionColumn.AMOUNT,
            options: {
                pin: "right",
            },
        },
        {
            id: TransactionColumn.ENTITY,
            options: {
                pin: "right",
            },
        },
    ],
});
